// first  section for ./index.page.tsx
import { FC } from 'react'
import NextLink from 'next/link'
import Image from 'next/image'

const CapsuleBar: FC<{ icon: string; text: string }> = ({ icon, text }) => {
  return (
    <div
      className={[
        'flex flex-row items-center w-fit rounded-full bg-white',
        'gap-x-[7px] px-3 py-1.5',
        'laptop:gap-x-4 laptop:px-6 laptop:py-3',
      ].join(' ')}
    >
      <div className={['relative', 'w-6 h-6', 'laptop:w-12 laptop:h-12'].join(' ')}>
        <Image alt="icon" src={icon} layout="fill" />
      </div>
      <span className={['text-black/90 font-normal', 'text-14', 'laptop:text-24'].join(' ')}>{text}</span>
    </div>
  )
}

const SectionTwo: FC = () => {
  const sectionClass = [
    'flex flex-row justify-center bg-gradient-to-l from-[#ffa365] to-[#fc7216] w-full relative',
    'px-6 pt-15',
    'laptop:h-845px laptop:p-0',
  ].join(' ')

  const Icon1 = 'https://cdn.pudutech.com/website/images/landingpage-texas/s2-icon1.svg'
  const Icon2 = 'https://cdn.pudutech.com/website/images/landingpage-texas/s2-icon2.svg'
  const Icon3 = 'https://cdn.pudutech.com/website/images/landingpage-texas/s2-icon3.svg'
  const Icon4 = 'https://cdn.pudutech.com/website/images/landingpage-texas/s2-icon4.svg'
  const capsuleBars = [
    { icon: Icon1, text: 'Improve Labor Efficiency' },
    { icon: Icon2, text: 'Customer Attraction , Revenue Boost' },
    { icon: Icon3, text: 'Improve Customer Satisfaction' },
    { icon: Icon4, text: 'Improve Employee Experience' },
  ]

  const Bella = 'https://cdn.pudutech.com/website/images/landingpage-texas/bella.png'

  return (
    <section className={sectionClass}>
      <div className={['flex items-center', 'flex-col gap-6', 'laptop:flex-row laptop:gap-94px'].join(' ')}>
        <div className={['', 'w-full', 'laptop:w-562px'].join(' ')}>
          <div className="flex flex-col gap-y-3 laptop:gap-y-4">
            {capsuleBars.map((bar) => (
              <CapsuleBar key={bar.text} icon={bar.icon} text={bar.text} />
            ))}
          </div>

          <p className="text-white text-14 laptop:text-20 font-medium mt-8 laptop:mt-16">
            Food Running Robot improves restaurant workflow by helping with dish deliveries and relieving waiters of
            heavy lifting. BellaBot attracts customers with its attractive appearance while waiters can focus on
            providing personalized service and introducing dishes. This allows restaurant staff to provide memorable
            experiences and improve communication with customers.
          </p>
        </div>

        <div className={['relative', 'w-272px h-356px', 'laptop:w-136 laptop:h-714px laptop:self-end'].join(' ')}>
          <Image alt="bella" src={Bella} layout="fill" />
        </div>
      </div>
    </section>
  )
}

export default SectionTwo
